<div class="toolbar-section main-toolbar"
  [class.has-additional-toolbar]="zoomParametersViewModel.showSelectionsFilterOptions">
  <div class="toolbar-control-content">
    <div class="horizontal-container">
      <div class="root-container">
        <div class="inline-command-bar">
          <div class="action-list-control-container">
            <div class="horizontal-flex-container rounded-actions">

              <!-- Toggle filter with populated operator -->
              <div class="command-bar-button-container">
                <nts-text-button [class.active]="zoomParametersViewModel.showFilterWithPopulatedOperator"
                  [title]="zoomParametersViewModel.filterWithPopulatedOperatorButtonTitle" icon="task-list"
                  (onClicked)="zoomParametersViewModel.toggleFilterWithPopulatedOperator()">
                </nts-text-button>
              </div>

              <!-- Toggle selection in filter -->
              <div class="command-bar-button-container">
                <nts-text-button [class.active]="zoomParametersViewModel.showSelectionsFilterOptions"
                  [title]="zoomParametersViewModel.selectionsFiltersOptionsButtonTitle" icon="eye-empty"
                  (onClicked)="zoomParametersViewModel.toggleSelectionsFilterOptions()">
                </nts-text-button>
              </div>

              <!-- Toggle advanced command -->
              <div class="command-bar-button-container">
                <nts-text-button [class.active]="zoomParametersViewModel.showAdvancedFiltersOptions"
                  [title]="zoomParametersViewModel.advancedButtonTitle" icon="fx-rounded"
                  (onClicked)="zoomParametersViewModel.toggleAdvancedFilters()"></nts-text-button>
              </div>

              <!-- Toggle sorting -->
              <div class="command-bar-button-container">
                <nts-text-button [class.active]="zoomParametersViewModel.showSortingGroups"
                  [title]="zoomParametersViewModel.sortingGroupButtonTitle" icon="sort"
                  (onClicked)="zoomParametersViewModel.toggleSortingGroups()"></nts-text-button>
              </div>

            </div>
          </div>
        </div>
      </div>

      <!-- Clear filters command -->
      <div class="horizontal-flex-container-item-layout">
        <div class="command-bar-button-container">
          <nts-text-button [title]="zoomParametersViewModel.clearCommand.tooltip"
            [label]="zoomParametersViewModel.clearCommand.displayName"
            [isDisabled]="!(zoomParametersViewModel.clearCommand.canExecute$ | async)"
            (onClicked)="zoomParametersViewModel.clearCommand.execute()"></nts-text-button>
        </div>
      </div>

    </div>
  </div>
</div>

<!-- Gestione comandi avanzati per la selezione dei campi -->
<div class="toolbar-section additional-toolbar" *ngIf="zoomParametersViewModel.showSelectionsFilterOptions">
  <div class="toolbar-control-content">
    <div class="horizontal-container">
      <div class="root-container">
        <div class="inline-command-bar">
          <div class="action-list-control-container">
            <div class="horizontal-flex-container">

              <div class="command-bar-button-container">
                <nts-text-button
                  [title]="'std_CMD_SelectAll_Tooltip' | NTSTranslate"
                  [label]="'std_CMD_SelectAll_DisplayName' | NTSTranslate" [icon]="'add-selection'"
                  (onClicked)="zoomParametersViewModel.selectAll()">
                </nts-text-button>
              </div>

              <div class="command-bar-button-container">
                <nts-text-button
                  [title]="'std_CMD_DeselectAll_Tooltip' | NTSTranslate"
                  [label]="'std_CMD_DeselectAll_DisplayName' | NTSTranslate" [icon]="'remove-selection'"
                  (onClicked)="zoomParametersViewModel.deselectAll()">
                </nts-text-button>
              </div>

            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
<!-- Fine Gestione comandi avanzati per la selezione dei campi -->

<div class="zoom-parameters-content zoom-parameter-content-desktop"
  [class.is-hidden]="zoomParametersViewModel.showSortingGroups"
  [class.has-additional-toolbar]="zoomParametersViewModel.showSelectionsFilterOptions">
  <div #parameterLabels class="parameter-column parameter-column-labels">
    <!-- <div class="zoom-parameter-label">{{ zoomParametersViewModel.headerPropertyName }}</div> -->
    <div
      *ngFor="let filterVm of (zoomParametersViewModel.filters | zoomAvailablesFilter: zoomParametersViewModel.showFilterWithPopulatedOperator)"
      class="zoom-filter-name level-{{filterVm.metaData.level}}">

      <div class="zoom-filter-name-container">
        <nts-base-checkbox-text-box
          *ngIf="zoomParametersViewModel.showSelectionsFilterOptions"
          (onChange)="zoomParametersViewModel.notifyModified()"
          [(checkStatus)]="filterVm.isSelected"
          [label]="filterVm.propertyNameMap.displayName"
          [isDisabled]="!filterVm.isSelectable">
        </nts-base-checkbox-text-box>

        <nts-label-box (click)="findExternal($event, filterVm)"
          [class.label-multiline]="filterVm.operator.currentValue == zoomParametersViewModel.filterOperators.Between"
          [class.zoom-label]="filterVm.externalDomainModelNameToZoom !== '' && filterVm.islocked === false"
          [title]="filterVm.propertyNameMap.displayName"
          [label]="filterVm.propertyNameMap.displayName"></nts-label-box>

        <ng-container *ngIf="filterVm.isOperatorSupported | async">
          <div class="white-space-container"
            *ngIf="filterVm.operator.currentValue == zoomParametersViewModel.filterOperators.In && isEnumZoomFilterViewModel(filterVm)">
            <div *ngFor="let filterIn of filterVm.filterValues" class="white-space"></div>
          </div>
          <div class="white-space-container"
            *ngIf="filterVm.operator.currentValue == zoomParametersViewModel.filterOperators.In && isExternalZoomFilterViewModel(filterVm)">
            <div *ngFor="let filterIn of filterVm.filterValues" class="white-space"></div>
          </div>
          <div class="white-space-container"
            *ngIf="filterVm.operator.currentValue == zoomParametersViewModel.filterOperators.Between">
            <div class="white-space"></div>
            <div class="white-space"></div>
          </div>
          <div class="white-space-container"
            *ngIf="filterVm.operator.currentValue == zoomParametersViewModel.filterOperators.In && isDateTimeZoomFilterViewModel(filterVm)">
            <div *ngFor="let filterIn of filterVm.filterDateTimeValues" class="white-space"></div>
          </div>
        </ng-container>

      </div>

      <div class="zoom-filter-action-container">
        <nts-text-button *ngIf="filterVm.externalDomainModelNameToZoom !== '' && filterVm.islocked === false"
          [icon]="(filterVm.isLoading$ | async) ? 'refresh-animated' : 'search'"
          (onClicked)="findExternal($event, filterVm)">
        </nts-text-button>

        <nts-text-button
          *ngIf="isExpandableFilter(filterVm) && !zoomParametersViewModel.showFilterWithPopulatedOperator && filterVm.islocked == false"
          [title]="((filterVm.isCollapsed$ | async) ? 'std_ExpandableShowMore_Description' : 'std_ExpandableShowLess_Description') | NTSTranslate"
          [icon]="(filterVm.isCollapsed$ | async) ? 'eye-alt' : 'eye-close'"
          (onClicked)="toggleExpandableFilter(filterVm)">
        </nts-text-button>
      </div>

    </div>
  </div>

  <div #parameterOperators class="parameter-column parameter-column-operators">
    <div
      *ngFor="let filterVm of (zoomParametersViewModel.filters | zoomAvailablesFilter: zoomParametersViewModel.showFilterWithPopulatedOperator)"
      class="filter-operator">
      <nts-zoom-filter-operator-text-box [operator]="filterVm.operator"></nts-zoom-filter-operator-text-box>
      <ng-container *ngIf="filterVm.isOperatorSupported | async">
        <ng-container
          *ngIf="filterVm.operator.currentValue == zoomParametersViewModel.filterOperators.In && (isDateTimeZoomFilterViewModel(filterVm))">
          <div *ngFor="let filterIn of filterVm.filterDateTimeValues | slice:0:-1" class="white-space"></div>
        </ng-container>
        <ng-container
          *ngIf="filterVm.operator.currentValue == zoomParametersViewModel.filterOperators.In && isEnumZoomFilterViewModel(filterVm)">
          <div *ngFor="let filterIn of filterVm.filterValues | slice:0:-1" class="white-space"></div>
        </ng-container>
        <ng-container
          *ngIf="filterVm.operator.currentValue == zoomParametersViewModel.filterOperators.In && isExternalZoomFilterViewModel(filterVm)">
          <div *ngFor="let filterIn of filterVm.filterValues | slice:0:-1" class="white-space"></div>
        </ng-container>
        <ng-container *ngIf="filterVm.operator.currentValue == zoomParametersViewModel.filterOperators.Between">
          <div class="white-space"></div>
        </ng-container>
      </ng-container>
    </div>
  </div>

  <div #parameterValues class="parameter-column parameter-values">
    <div
      *ngFor="let filterVm of (zoomParametersViewModel.filters | zoomAvailablesFilter: zoomParametersViewModel.showFilterWithPopulatedOperator)"
      class="filter-value-container"
      [class.filter-value-between]="filterVm.operator.currentValue == zoomParametersViewModel.filterOperators.Between">

      <div class="filter-value" *ngIf="!(filterVm.isOperatorSupported | async)" #filters>
        <div class="filter-value-list" *ngIf="!filterVm.showVariables" @openClose>
          <div class="unsupported-operator">Operatore non supportato</div>
        </div>
      </div>

      <ng-container *ngIf="filterVm.isOperatorSupported | async">

        <div class="filter-value" *ngIf="filterVm.operator.currentValue != zoomParametersViewModel.filterOperators.In"
          #filters
          [ngClass]="{'advanced-filters-show': zoomParametersViewModel.showAdvancedFiltersOptions }">

          <div class="filter-value-list" *ngIf="!filterVm.showVariables" @openClose>
            <ng-container *ngIf="isFilterString(filterVm.filterValue) && !filterVm.showVariables">
              <nts-zoom-filter-string-text-box *ngIf="isStringZoomFilterViewModel(filterVm)"
                [filter]="filterVm"
                [propertyViewModel]="filterVm.filterValue" (focus)="parameterFocus($event, filterVm)"
                (keyDown)="keyDown($event)">
              </nts-zoom-filter-string-text-box>
            </ng-container>

            <ng-container *ngIf="isFilterGuid(filterVm.filterValue) && !filterVm.showVariables">
              <nts-zoom-filter-string-text-box *ngIf="isGuidZoomFilterViewModel(filterVm)"
                [filter]="filterVm"
                [validateChipsFunc]="guidMaskSettings.validateMaskOnBlurFunc"
                [maskSettings]="guidMaskSettings"
                [propertyViewModel]="filterVm.filterValue" (focus)="parameterFocus($event, filterVm)"
                (keyDown)="keyDown($event)">
              </nts-zoom-filter-string-text-box>
            </ng-container>

            <ng-container *ngIf="isFilterNumeric(filterVm.filterValue) && !filterVm.showVariables">
              <nts-zoom-filter-numeric-text-box *ngIf="isNumericZoomFilterViewModel(filterVm)"
                [filter]="filterVm"
                [propertyViewModel]="filterVm.filterValue" [updateOnBlur]="true"
                (focus)="parameterFocus($event, filterVm)"
                (keyDown)="keyDown($event)">
              </nts-zoom-filter-numeric-text-box>
            </ng-container>

            <ng-container *ngIf="isFilterExternal(filterVm.filterValue) && !filterVm.showVariables">
              <nts-zoom-filter-external-text-box *ngIf="isExternalZoomFilterViewModel(filterVm)"
                [filter]="filterVm"
                [propertyViewModel]="filterVm.filterValue" [updateOnBlur]="true"
                (focus)="parameterFocus($event, filterVm)"
                (keyDown)="keyDown($event)">
              </nts-zoom-filter-external-text-box>
            </ng-container>

            <ng-container *ngIf="isFilterBool(filterVm.filterValue) && !filterVm.showVariables">
              <nts-zoom-filter-bool-text-box *ngIf="isBoolZoomFilterViewModel(filterVm)"
                [filter]="filterVm"
                [propertyViewModel]="filterVm.filterValue">
              </nts-zoom-filter-bool-text-box>
            </ng-container>

            <ng-container *ngIf="isFilterDate(filterVm.filterValue) && !filterVm.showVariables">
              <nts-zoom-filter-date-text-box *ngIf="isDateTimeZoomFilterViewModel(filterVm)"
                [filter]="filterVm"
                [propertyViewModel]="filterVm.filterValue">
              </nts-zoom-filter-date-text-box>
            </ng-container>

            <ng-container *ngIf="isFilterDateTimeOffset(filterVm.filterValue) && !filterVm.showVariables">
              <nts-zoom-filter-date-offset-text-box
                *ngIf="isDateTimeZoomFilterViewModel(filterVm)"
                [filter]="filterVm"
                [propertyViewModel]="filterVm.filterValue">
              </nts-zoom-filter-date-offset-text-box>
            </ng-container>

            <ng-container *ngIf="isFilterEnum(filterVm.filterValue) && !filterVm.showVariables">
              <nts-zoom-filter-enum-text-box *ngIf="isEnumZoomFilterViewModel(filterVm)"
                [filter]="filterVm"
                [propertyViewModel]="filterVm.filterValue">
              </nts-zoom-filter-enum-text-box>
            </ng-container>
          </div>

          <div class="variables-container" *ngIf="filterVm.showVariables" @openClose>
            <nts-base-enum-text-box *ngIf="filterVm.showVariables" [value]="filterVm.filterVariableValue"
              optionLabel="description"
              dataKey="key" [options$]="filterVm.filterVariables$" [appendTo]="'body'"
              [isDisabled]="filterVm.OperatorDoesNotRequireValue"
              [placeholder]="zoomParametersViewModel.variablesPlaceholderTitle"
              (onChange)="zoomParametersViewModel.onFilterVariableChange($event, filterVm)"
              (onBlur)="zoomParametersViewModel.onFilterVariableBlur(filterVm)" [isNullable]="true">
            </nts-base-enum-text-box>
          </div>

          <!-- <div class="add-in-button-container" *ngIf="filterVm.operator.currentValue == zoomParametersViewModel.filterOperators.In">
              <nts-text-button
                  [title]="zoomParametersViewModel.addInFieldButtonTitle" [icon]="'plus'"
                  (onClicked)="zoomParametersViewModel.addInField(filterVm)">
              </nts-text-button>
            </div> -->



          <div class="variables-button-container"
            *ngIf="zoomParametersViewModel.showAdvancedFiltersOptions && (filterVm.filterVariables$ | async)?.length > 0">
            <nts-text-button *ngIf="zoomParametersViewModel.showAdvancedFiltersOptions"
              [title]="zoomParametersViewModel.variablesButtonTitle" [icon]="'filter'"
              [class.var-visible]="filterVm.showVariables"
              (onClicked)="zoomParametersViewModel.toogleVariablesVisibility(filterVm)">
            </nts-text-button>
          </div>
        </div>

        <!-- Between -->
        <div class="filter-value"
          *ngIf="filterVm.operator.currentValue == zoomParametersViewModel.filterOperators.Between"
          #filters
          [ngClass]="{'advanced-filters-show': zoomParametersViewModel.showAdvancedFiltersOptions, 'filter-value-between':filterVm.operator.currentValue == zoomParametersViewModel.filterOperators.Between }">
          <div class="filter-value-list" *ngIf="!filterVm.showVariables2" @openClose>

            <ng-container
              *ngIf="isFilterString(filterVm.filterValue) && !filterVm.showVariables2 && isFilterString(filterVm.filterValue2)">
              <ng-container *ngIf="isStringZoomFilterViewModel(filterVm)">
                <nts-zoom-filter-string-text-box [filter]="filterVm" [propertyViewModel]="filterVm.filterValue2"
                  [updateOnBlur]="true"
                  (focus)="parameterFocus($event, filterVm)" (keyDown)="keyDown($event)"
                  [ngClass]="'filter-value-text-between'">
                </nts-zoom-filter-string-text-box>
              </ng-container>
            </ng-container>

            <ng-container
              *ngIf="isFilterNumeric(filterVm.filterValue) && !filterVm.showVariables2 && isFilterNumeric(filterVm.filterValue2)">
              <ng-container *ngIf="isNumericZoomFilterViewModel(filterVm)">
                <nts-zoom-filter-numeric-text-box [filter]="filterVm" [propertyViewModel]="filterVm.filterValue2"
                  [updateOnBlur]="true"
                  (focus)="parameterFocus($event, filterVm)" (keyDown)="keyDown($event)"
                  [ngClass]="'filter-value-text-between'">
                </nts-zoom-filter-numeric-text-box>
              </ng-container>
            </ng-container>

            <ng-container
              *ngIf="isFilterExternal(filterVm.filterValue) && !filterVm.showVariables2 && isFilterExternal(filterVm.filterValue2)">
              <ng-container *ngIf="isExternalZoomFilterViewModel(filterVm)">
                <nts-zoom-filter-external-text-box [filter]="filterVm" [propertyViewModel]="filterVm.filterValue2"
                  (focus)="parameterFocus($event, filterVm)" (keyDown)="keyDown($event)" [updateOnBlur]="true">
                </nts-zoom-filter-external-text-box>
              </ng-container>
            </ng-container>

            <ng-container
              *ngIf="isFilterDate(filterVm.filterValue) && !filterVm.showVariables2 && isFilterDate(filterVm.filterValue2)">
              <nts-zoom-filter-date-text-box [propertyViewModel]="filterVm.filterValue2"
                [ngClass]="'filter-value-text-between'">
              </nts-zoom-filter-date-text-box>
            </ng-container>

            <ng-container
              *ngIf="isFilterDateTimeOffset(filterVm.filterValue) && !filterVm.showVariables2 && isFilterDateTimeOffset(filterVm.filterValue2)">
              <nts-zoom-filter-date-offset-text-box [propertyViewModel]="filterVm.filterValue2"
                [ngClass]="'filter-value-text-between'">
              </nts-zoom-filter-date-offset-text-box>
            </ng-container>
          </div>

          <div class="variables-container" *ngIf="filterVm.showVariables2" @openClose>
            <div class="mt-1"
              *ngIf="filterVm.showVariables2 && filterVm.operator.currentValue == zoomParametersViewModel.filterOperators.Between"
              @openClose>
              <nts-base-enum-text-box *ngIf="filterVm.showVariables2" [value]="filterVm.filterVariable2Value"
                optionLabel="description" dataKey="key" [options$]="filterVm.filterVariables$" [appendTo]="'body'"
                [isDisabled]="filterVm.OperatorDoesNotRequireValue"
                [placeholder]="zoomParametersViewModel.variablesPlaceholderTitle"
                (onChange)="zoomParametersViewModel.onFilterVariable2Change($event,filterVm)" [isNullable]="true"
                (onBlur)="zoomParametersViewModel.onFilterVariable2Blur(filterVm)" [isNullable]="true">
              </nts-base-enum-text-box>
            </div>
          </div>
          <div class="variables-button-container"
            *ngIf="zoomParametersViewModel.showAdvancedFiltersOptions && (filterVm.filterVariables$ | async)?.length > 0">

            <nts-text-button
              *ngIf="zoomParametersViewModel.showAdvancedFiltersOptions && filterVm.operator.currentValue == zoomParametersViewModel.filterOperators.Between"
              [title]="zoomParametersViewModel.variablesButtonTitle" [icon]="'filter'"
              [class.var-visible]="filterVm.showVariables2"
              (onClicked)="zoomParametersViewModel.toogleVariables2Visibility(filterVm)">
            </nts-text-button>
          </div>
        </div>

        <!-- In -->
        <div class="filter-value" *ngIf="filterVm.operator.currentValue == zoomParametersViewModel.filterOperators.In"
          #filters>

          <div class="filter-value-list" *ngIf="!filterVm.showVariables" @openClose>

            <ng-container *ngIf="isFilterString(filterVm.filterValue) && !filterVm.showVariables">
              <nts-zoom-filter-string-text-box *ngIf="isStringZoomFilterViewModel(filterVm)"
                [filter]="filterVm"
                [propertyViewModel]="filterVm.filterValue" (focus)="parameterFocus($event, filterVm)"
                (keyDown)="keyDown($event)">
              </nts-zoom-filter-string-text-box>
            </ng-container>

            <ng-container *ngIf="isFilterNumeric(filterVm.filterValue) && !filterVm.showVariables">
              <nts-zoom-filter-numeric-text-box *ngIf="isNumericZoomFilterViewModel(filterVm)"
                [filter]="filterVm"
                [propertyViewModel]="filterVm.filterValue" [updateOnBlur]="true"
                (focus)="parameterFocus($event, filterVm)"
                (keyDown)="keyDown($event)">
              </nts-zoom-filter-numeric-text-box>
            </ng-container>

            <ng-container *ngIf="isEnumZoomFilterViewModel(filterVm) && !filterVm.showVariables">
              <nts-zoom-filter-enum-text-box [propertyViewModel]="filterIn"
                *ngFor="let filterIn of filterVm.filterValues">
              </nts-zoom-filter-enum-text-box>
            </ng-container>

            <ng-container *ngIf="isExternalZoomFilterViewModel(filterVm) && !filterVm.showVariables">
              <nts-zoom-filter-external-text-box [filter]="filterVm"
                [propertyViewModel]="getExternalZoomPropertyViewModel(filterIn)" (keyDown)="keyDown($event)"
                [updateOnBlur]="true" (focus)="parameterFocus($event, filterVm)"
                *ngFor="let filterIn of filterVm.filterValues">
              </nts-zoom-filter-external-text-box>
            </ng-container>

            <ng-container *ngIf="isDateTimeZoomFilterViewModel(filterVm)">
              <ng-container *ngIf="isFilterDate(filterVm.filterValue) && !filterVm.showVariables">
                <nts-zoom-filter-date-text-box [propertyViewModel]="getFilterDate(filterIn)"
                  *ngFor="let filterIn of filterVm.filterDateTimeValues"
                  [ngClass]="'filter-value-text-in'">
                </nts-zoom-filter-date-text-box>
              </ng-container>

              <ng-container *ngIf="isFilterDateTimeOffset(filterVm.filterValue) && !filterVm.showVariables">
                <nts-zoom-filter-date-offset-text-box [propertyViewModel]="getFilterDateTimeOffset(filterIn)"
                  *ngFor="let filterIn of filterVm.filterDateTimeValues"
                  [ngClass]="'filter-value-text-in'">
                </nts-zoom-filter-date-offset-text-box>
              </ng-container>
            </ng-container>

          </div>

          <div class="in-buttons-container"
            *ngIf="isDateTimeZoomFilterViewModel(filterVm)">
            <div class="filter-value-actions"
              *ngFor="let filterIn of filterVm.filterDateTimeValues; let last = last; let first = first">
              <nts-text-button
                [title]="zoomParametersViewModel.addInFieldButtonTitle" *ngIf="last" [icon]="'plus'"
                (onClicked)="zoomParametersViewModel.addInField(filterVm)">
              </nts-text-button>
              <nts-text-button
                [title]="zoomParametersViewModel.addInFieldButtonTitle" *ngIf="!first" [icon]="'trash'"
                (onClicked)="zoomParametersViewModel.deleteInField(filterVm, filterIn)">
              </nts-text-button>
            </div>
          </div>

          <div class="in-buttons-container" *ngIf="isEnumZoomFilterViewModel(filterVm)">

            <div class="filter-value-actions"
              *ngFor="let filterIn of filterVm.filterValues; let last = last; let first = first">
              <nts-text-button
                [title]="zoomParametersViewModel.addInFieldButtonTitle" *ngIf="last" [icon]="'plus'"
                (onClicked)="zoomParametersViewModel.addInField(filterVm)">
              </nts-text-button>
              <nts-text-button
                [title]="zoomParametersViewModel.addInFieldButtonTitle" *ngIf="!first" [icon]="'trash'"
                (onClicked)="zoomParametersViewModel.deleteInField(filterVm, filterIn)">
              </nts-text-button>
            </div>

          </div>

          <div class="in-buttons-container" *ngIf="isExternalZoomFilterViewModel(filterVm)">

            <div class="filter-value-actions"
              *ngFor="let filterIn of filterVm.filterValues; let last = last; let first = first">
              <nts-text-button
                [title]="zoomParametersViewModel.addInFieldButtonTitle" *ngIf="last" [icon]="'plus'"
                (onClicked)="zoomParametersViewModel.addInField(filterVm)">
              </nts-text-button>
              <nts-text-button
                [title]="zoomParametersViewModel.addInFieldButtonTitle" *ngIf="!first" [icon]="'trash'"
                (onClicked)="zoomParametersViewModel.deleteInField(filterVm, filterIn)">
              </nts-text-button>
            </div>

          </div>

        </div>
      </ng-container>
    </div>
  </div>

</div>

<nts-zoom-parameters-sorting-groups *ngIf="zoomParametersViewModel.filters"
  [class.is-hidden]="!zoomParametersViewModel.showSortingGroups"
  [parameters]="zoomParametersViewModel"
  (onSortingGroupsChanged)="zoomParametersViewModel.notifyModified()">
</nts-zoom-parameters-sorting-groups>